var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVietnam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 21,
    viewBox: "0 0 31 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.891 0H3.10902C1.39196 0 0 1.41441 0 3.15917V17.8408C0 19.5856 1.39196 21 3.10902 21H27.891C29.608 21 31 19.5856 31 17.8408V3.15917C31 1.41441 29.608 0 27.891 0Z",
    fill: "#D8251D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5035 5.59912L16.6833 9.30832H20.4863L17.4536 11.6354L18.5848 15.401L15.5035 13.0598L12.4222 15.3728L13.5187 11.6495L10.5138 9.30832H14.2335L15.5035 5.59912Z",
    fill: "#F9D604"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVietnam);
export default __webpack_public_path__ + "static/media/Vietnam.f747688fc3cfd384940a7337537cd7c0.svg";
export { ForwardRef as ReactComponent };